import { DeliveryMethodAndLanguageSelection } from '../../components/DeliveryMethodAndLanguageSelection.js';
import type { CLDropdownItem } from '../../../../common/types/componentLibrary';

interface BillingAccountPaperDeliveryMethodProps {
  deliveryMethodOptions: CLDropdownItem[];
  disabled?: boolean;
  onDeliveryMethodChange?: (newMethod: string) => void;
}

export const BillingAccountPaperDeliveryMethodEdit = ({
  deliveryMethodOptions,
  disabled = false,
  onDeliveryMethodChange,
}: BillingAccountPaperDeliveryMethodProps) => (
  <DeliveryMethodAndLanguageSelection
    deliveryMethodOptions={deliveryMethodOptions}
    disabled={disabled}
    onDeliveryMethodChange={onDeliveryMethodChange}
  />
);
